import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const ProductDetailPage = lazy(() => import('@/pages/products/detail'));

export const Route = createFileRoute('/products/$slug')({
  component: function ProductRoute() {
    const { slug } = Route.useParams();
    return (
      <Suspense fallback={<TableSkeleton />}>
        <ProductDetailPage slug={slug} />
      </Suspense>
    );
  },
});
